import { render, staticRenderFns } from "./tongue-report.vue?vue&type=template&id=3513a42e&scoped=true&"
import script from "./tongue-report.vue?vue&type=script&lang=ts&"
export * from "./tongue-report.vue?vue&type=script&lang=ts&"
import style0 from "./tongue-report.vue?vue&type=style&index=0&id=3513a42e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3513a42e",
  null
  
)

export default component.exports